module.exports = __webpack_public_path__ + "img/empty-box.951d9fda.svg";